// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qea9","type":"styles_type__17uqN","choices":"styles_choices__39VX6"};